import { createAction } from "typesafe-actions";

export const setSidebarCollapsed = createAction("INTERNAL_SET_SIDEBAR_COLLAPSED")<boolean>();

export const setPresentMode = createAction("INTERNAL_SET_PRESENT_MODE")<boolean>();

export const setFullScreen = createAction("INTERNAL_SET_FULL_SCREEN")<boolean>();
